import { FC, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
import { LandingPageStyle } from './landingPage.types';

interface Props extends PropsWithChildren {
  color: LandingPageStyle;
  imageUrl: string;
  title: string;
  stepNumber: number;
  imageContainerClassName?: string;
}

export const LandingPageSection: FC<Props> = ({
  color,
  imageUrl,
  title,
  stepNumber,
  imageContainerClassName,
  children
}) => {
  const imageOnLeft = stepNumber % 2 === 0;

  return (
    <div
      className="py-10 overflow-hidden h-[260px]"
      style={{
        backgroundColor: imageOnLeft ? 'rgba(0,0,0,0.05)' : undefined
      }}
    >
      <div
        className="flex max-w-5xl w-full h-full mx-auto justify-between"
        style={{
          flexDirection: imageOnLeft ? 'row' : 'row-reverse'
        }}
      >
        <div
          className={twMerge(
            'w-[45%] rounded-md relative bg-cover overflow-hidden',
            imageOnLeft ? 'bg-center' : 'bg-left',
            imageContainerClassName
          )}
          style={{ backgroundImage: `url(${imageUrl})` }}
        >
          <div
            className={twMerge(
              'absolute bottom-5 text-white text-2xl flex flex-col max-w-[50%] z-10',
              imageOnLeft ? 'right-5 text-right items-end' : 'left-5 text-left items-start'
            )}
          >
            <div>{`Step ${stepNumber}:`}</div>
            <div>{title}</div>
          </div>
          <div
            className={twMerge(
              'absolute w-[110%] h-[300%] top-[-120px] bg-gradient-to-r to-transparent',
              imageOnLeft ? 'bg-gradient-to-l rotate-[30deg]' : 'bg-gradient-to-r  rotate-[-30deg] left-[-50px]',
              color === LandingPageStyle.BLUE ? 'from-primary-700 via-primary-700' : '',
              color === LandingPageStyle.ORANGE ? 'from-secondary-700 via-secondary-700' : ''
            )}
          ></div>
        </div>
        <div className="w-[45%] flex items-center justify-center gap-5 text-lg flex-col text-center px-10 font-semibold">
          {children}
        </div>
      </div>
    </div>
  );
};
